import { jsx as m } from "react/jsx-runtime";
function d({
  large: t,
  open: n,
  small: e,
  reversed: o,
  legal: a,
  className: s = "",
  children: l,
  testId: r,
  ...C
}) {
  const i = [
    "Content",
    t && "Content--large",
    n && "Content--open",
    e && "Content--small",
    o && "Content--reversed",
    a && "Content--legal",
    s
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ m("div", { className: i, ...C, "data-testid": r, children: l });
}
export {
  d as Content
};
//# sourceMappingURL=Content.mjs.map
